import {
	DESKTOP_M_BP,
	DESKTOP_SM_BP,
	MOBILE_L_BP,
	TABLET_M_BP,
} from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
import styled from "styled-components";
import { formatColor } from "@website-builder/utilities/utils/DesignUtils.js";
const isB2U = process.env.GATSBY_BUSINESS_VERTICAL === "b2u";

export const NavHeaderWrapper = styled.div`
	height: ${({ isPencilBannerClosed }) => (isPencilBannerClosed ? 0 : "56px")};
`;
export const PencilBannerWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	background-color: ${({ bgColor }) => (bgColor ? bgColor : "#0E5642")};
	padding: 0px 24px;
	${({ stickyHeader }) =>
		stickyHeader &&
		`
        position: fixed; 
        z-index: 20;
    `}

	.pencil-banner-text {
		width: 100%;
		height: 56px;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		padding: 8px 0;
		padding-right: 16px;
		overflow: auto;
		p {
			color: ${({ textColor }) => (textColor ? textColor : "#C3F570")};
			margin: ${({ hasIcons }) => hasIcons && "0 6px"};
		}
		a {
			color: ${({ textColor }) =>
				textColor ? textColor : "#C3F570"} !important;
		}
	}

	.closeButtonWrapper {
		cursor: pointer;
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding: 0px 16px;
	}

	.pencil-banner {
		background-color: #fff;
	}
`;

export const NavWrapper = styled.header`
	width: 100%;
	&.up-header {
		//overriding the inline style. So !important is difficult to replace
		background-color: var(--theme-primary) !important;
	}
	${({ stickyHeader }) =>
		stickyHeader
			? `
        position: fixed; 
        transition: opacity 0.2s ease-out, background-color 0.2s ease-out;
    `
			: `
        position: absolute;
    `}
	top: ${({ isPencilBannerClosed }) => (isPencilBannerClosed ? 0 : "56px")};
	z-index: 20;
	${({ showMobileMenu }) =>
		showMobileMenu &&
		`
    height: 100vh;
    overflow: auto;
    overscroll-behavior: contain;
    `}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		.navigation-header-main-nav {
			${({ isLogoCenteredInMobile }) =>
				isLogoCenteredInMobile
					? `
      justify-content: center;
      align-items: center;
    `
					: ""}
		}
	}
`;

export const TopNav = styled.div`
	background: ${({ bgColor }) =>
		bgColor ? formatColor(bgColor) : "var(--primary-neutral-nightshade-800)"};
	padding-left: 90px;
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		display: none;
	}
`;

export const TopNavItem = styled.span`
	.top-nav-link {
		color: ${({ textColor }) =>
			textColor ? formatColor(textColor) : "var(--primary-neutral-white)"};
		margin: 0px 15px;
		padding: 4px 14px;
		&:hover,
		&:focus {
			background: ${({ hoverColor }) =>
				hoverColor ? formatColor(hoverColor) : "var(--primary-green-400)"};
			color: ${({ textHoverColor }) =>
				textHoverColor
					? formatColor(textHoverColor)
					: "var(--primary-neutral-nightshade-800)"};
		}
	}
`;

export const TopNavMobile = styled.div`
	margin-left: 25px;
	margin-top: -10px;
`;

export const TopNavMobileItem = styled.div`
	.top-nav-mobile-link {
		margin-top: 20px;
		p {
			color: var(--secondary-purple-300);
			font-size: 16px;
		}
	}
`;

export const AncillaryNav = styled.div`
	height: 32px;
	width: 100%;
	border-bottom: 1px solid
		${({ lightHeader }) =>
			!lightHeader ? "rgba(5, 8, 43, 0.6)" : "rgba(237, 239, 238, 0.5)"};
	display: flex;
	justify-content: flex-end;
	align-items: center;
	top: 0;
	z-index: 20;
	padding-right: 4rem;
	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		padding-right: 2rem;
	}
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding-right: 1.5rem;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		display: none;
	}
`;

export const AncillaryNavActions = styled.div`
	display: flex;
	gap: 1.5rem;

	.call-us-link {
		svg path {
			stroke: var(--theme-light-font-color);
		}
	}

	.header-login-link,
	.call-us-link {
		background: transparent;
		border: none;
		box-shadow: none;
	}
`;

export const NavBar = styled.nav`
	height: 72px;
	width: 100%;
	display: flex;
	gap: 3rem;
	justify-content: space-between;
	align-items: center;
	top: 0;
	z-index: 20;
	padding-left: 4rem;
	padding-right: 4rem;
	.mobile-nav-action {
		display: none;
	}
	.desktop-nav-action {
		display: flex;
	}
	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		padding-left: 2rem;
		padding-right: 2rem;
		gap: 2rem;
	}
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding-left: 1.5rem;
		padding-right: 1.5rem;
		gap: 1.5rem;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		.mobile-nav-action {
			display: ${({ disableHamburger }) =>
				disableHamburger ? "none" : "flex"};
		}
		.desktop-nav-action {
			display: ${({ disableHamburger }) =>
				disableHamburger ? "flex" : "none"};
		}
		.navigation-header-desktop-menu {
			display: none;
			margin-right: 1.5rem;
		}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding-left: 1rem;
		padding-right: 1rem;
	}
`;

export const NavBrand = styled.div`
	width: fit-content;
	& img {
		${() =>
			`${
				isB2U
					? `
        height: auto;
        width: 100%;
      `
					: ""
			}`}
		max-width: ${(props) =>
			props.logoWidth ? `${props.logoWidth}px` : "300px"}
	}
`;

export const NavMenu = styled.div`
	display: flex;
	gap: 2.5rem;
	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		gap: 2rem;
	}
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		gap: 1.5rem;
	}

	.bold-link:hover,
	.bold-link:focus {
		& p {
			font-weight: var(--fw-haffer-xh-2);
		}
	}
	.nav-additional-link:hover,
	.nav-additional-link:focus {
		cursor: pointer;
		& > * {
			color: ${({ lightHeader }) =>
				!lightHeader
					? "var(--primary-forest-400) !important"
					: "var(--primary-green-400) !important"};
		}
	}
`;
export const NavMenuMobile = styled.div`
	width: 100%;
	min-height: calc(100vh - 71.5px);
	background-color: #fff;
	display: none;

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		display: ${({ showMenu }) => (showMenu ? "block" : "none")};
	}
`;
export const NavMenuMobileFooter = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	align-items: center;
	padding: 24px;
	gap: 3rem;

	.call-us-link {
		background: transparent;
		border: none;
		box-shadow: none;
	}

	& .footerButtons {
		display: flex;
		gap: 24px;
		width: 100%;
		& button {
			width: 100%;
		}
	}
`;

export const NavActions = styled.div`
	.nav-hamburger-icon {
		background: transparent;
		border: none;
		box-shadow: none;
		padding: 0;
	}

	width: max-content;
	display: flex;
	align-items: center;
	gap: 1rem;
	white-space: nowrap;
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		gap: 2rem;
	}
`;

export const DropdownLabelWrapper = styled.button`
	background: transparent;
	border: none;
	text-align: left;
	padding: 0;

	position: relative;
	display: flex;
	align-items: center;
	gap: 4px;
	white-space: nowrap;
	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		white-space: unset;
	}

	&:hover,
	&:focus {
		cursor: pointer;
		& > * {
			color: ${({ lightHeader }) =>
				!lightHeader
					? "var(--primary-forest-400) !important"
					: "var(--primary-green-400) !important"};
		}
		& i {
			border-top: 4.5px solid
				${({ lightHeader }) =>
					!lightHeader
						? "var(--primary-forest-400) !important"
						: "var(--primary-green-400) !important"};
		}
	}
`;

export const Caret = styled.i`
	width: 0;
	height: 0;
	display: inline-block;
	border-left: 4.5px solid transparent;
	border-right: 4.5px solid transparent;
	border-top: 4.5px solid
		${({ color }) => `var(--${color.base}-${color.color}-${color.shade})`};
	transform: ${({ open }) => (open ? "rotateX(180deg)" : "rotateX(0deg)")};
	transition: transform 0.5s ease-out;
`;

export const UserAvatarWrapper = styled.div`
	display: flex;
	position: relative;
	align-items: center;
	.user-info-wrapper {
		display: flex;
		flex-direction: row;
		gap: 10px;
		cursor: pointer;
		.imageWrapper {
			border-radius: 25px;
			overflow: hidden;
			height: 20px;
			width: 20px;
		}
		img {
			height: 20px;
		}
	}
	.backdrop {
		display: ${(props) => (props.showUserMenu ? "block" : "none")};
		position: fixed;
		top: 0;
		bottom: 0;
		background: transparent;
		left: 0;
		right: 0;
		z-index: 4;
	}
	.userMenu {
		&:before {
			content: "";
			position: absolute;
			left: 50%;
			top: -10px;
			width: 0;
			height: 0;
			transform: translateX(-50%);
			border-left: 10px solid transparent;
			border-right: 10px solid transparent;
			border-bottom: 10px solid #48485e;
		}
		display: ${(props) => (props.showUserMenu ? "block" : "none")};
		position: absolute;
		background-color: #48485e;
		padding: 20px;
		top: 40px;
		left: -80px;
		min-width: 180px;
		z-index: 5;
		border-radius: 16px;
		a,
		span {
			color: var(--primary-neutral-white);
			cursor: pointer;
			display: block;
			font-family: var(--ff-haffer-xh);
			font-weight: var(--fw-haffer-xh-0);
			line-height: var(--lh-5);
			font-size: var(--fs-2);
			letter-spacing: var(--ls-0);
			text-decoration: none;
			margin-top: 0.5rem;
			margin-bottom: 0.5rem;
		}
		& hr {
			margin: 0;
		}
	}
	@media only screen and (max-width: ${DESKTOP_SM_BP - 1}px) {
		.user-info-wrapper {
			.userName {
				display: none;
			}
			.imageWrapper {
				border-radius: 15px;
				overflow: hidden;
				height: 32px;
				width: 32px;
			}
			img {
				height: 32px;
			}
		}
		.userMenu {
			&:before {
				left: 115px;
			}
			left: -100px;
			top: 50px;
		}
	}
`;

export const StickyHeaderWrapper = styled.div`
	display: none;
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		.navbar {
			display: flex;
			align-items: center;
			margin: 0;
			padding: 0;
			position: fixed;
			width: 100%;
			& .nav-item {
				background-color: ${({ backgroundColor }) => backgroundColor};
				text-align: center;
				height: 60px;
				display: flex;
				justify-content: center;
				align-items: center;
				& .nav-link {
					width: 100%;
					line-height: 60px;
					text-align: center;
					text-decoration: none;
					& p {
						color: ${({ linkColor }) => linkColor};
					}
					cursor: pointer;
				}
			}
			& .nav-item {
				flex-grow: 1;
				list-style: none;
				&:last-child {
					& button {
						height: 100%;
						border-radius: 0;
					}
					& .nav-link {
						background: ${({ buttonColor }) => buttonColor};
						color: ${({ buttonTextColor }) => buttonTextColor};
						text-decoration: none;
						font-size: 18px;
						font-weight: 700;
						padding: 0;
						border-radius: 0;
						border-width: 0;
					}
				}
			}
		}
		left: 0px;
		top: 0px;
		display: block;
		position: relative;
		height: 60px;
		z-index: 999;
	}
`;

export const MenuFooter = styled.div`
	margin-top: 16px;
	display: flex;
	flex-direction: column;

	& hr {
		width: 100%;
		margin-bottom: 16px;
	}

	& button {
		margin-top: 1rem;
	}
`;
